import React from "react";
import { Reveal } from "./Reveal";

export const Why = () => (
  <section className="relative py-24 md:py-32" data-testid="why-section">
    <div className="mx-auto max-w-4xl px-6 text-center md:px-12">
      <Reveal>
        <p className="text-sm font-semibold uppercase tracking-[0.15em] text-[#8AA583]">
          Why SisterSafe
        </p>
      </Reveal>
      <Reveal delay={0.08}>
        <h2 className="font-heading mt-5 text-4xl font-semibold leading-[1.15] tracking-tight text-[#111E16] md:text-5xl">
          Technology designed around{" "}
          <span className="text-[#2F5E43]">women's everyday lives.</span>
        </h2>
      </Reveal>
      <Reveal delay={0.16}>
        <p className="mx-auto mt-7 max-w-2xl text-lg leading-relaxed text-[#4A5F52]">
          SisterSafe was created because women deserve technology built specifically for
          them, not around fear, but around confidence, preparedness, and community. It's
          the quiet reassurance of knowing your people have your back, so you can move
          through the world feeling capable and free.
        </p>
      </Reveal>

      <Reveal delay={0.24}>
        <div className="mt-14 grid gap-6 sm:grid-cols-3">
          {[
            { k: "Confidence", v: "Move through your day feeling capable, not anxious." },
            { k: "Preparedness", v: "Simple tools ready the moment you might need them." },
            { k: "Community", v: "A network of women genuinely looking out for each other." },
          ].map((item, i) => (
            <div
              key={i}
              className="rounded-3xl border border-[#2F5E43]/5 bg-white p-7 text-left shadow-[0_8px_30px_rgba(0,0,0,0.04)]"
            >
              <h3 className="font-heading text-xl font-semibold text-[#2F5E43]">{item.k}</h3>
              <p className="mt-2 text-[#4A5F52]">{item.v}</p>
            </div>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);
